import React from 'react';
import axios from 'axios'
import { Table, Input, Button,Collapse,Popover,Popconfirm,message,Spin,Tabs } from 'antd';
import Highlighter from 'react-highlight-words';
import Icon from '@ant-design/icons';
import { SearchOutlined,DeleteOutlined,FundViewOutlined,LoadingOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import * as serverconfig from '../serverconn'
import LicenceCommoditiesForm from '../components/LicenceCommoditiesForm';
import Commodities_list from './Commodities_list';


var CryptoJS = require("crypto-js");

const { Panel } = Collapse;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

function callback(key) {
  console.log(key);
}
const { TabPane } = Tabs;


var token= ''
var bizuserid= ''


class CommoditiesTab extends React.Component {
  state = {
    searchText: '',
    searchedColumn: '',
    datarequested:true,

  };

  componentDidMount(){
    this.comp_reloaded()
    
}

comp_reloaded=()=>{

  if(localStorage.getItem("token")){
     token= localStorage.getItem("token")
  }else{
     token= ''
  }

  if(localStorage.getItem("bizuserid")){
    bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
 }else{
    bizuserid= ''
 }

  axios.defaults.headers={
    "Content-Type":"application/json",
    Authorization:`Token ${token}`
  }

  

  this.setState({datarequested:false})




}




  render() {
    

    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
              <Spin size="large">
                <div className="content" />
              </Spin>      
         </div>
      )

    }else{
      return(
        <div>

          <Tabs
            defaultActiveKey="1"
            onChange={() => {}}
            tabPosition={'top'}
          >
             <TabPane tab={"Commodities"} key="1">
              <Commodities_list
              licence_id={this.props.licence_id}
              />
             </TabPane>
             

             <TabPane tab="Commodities Attachment Form" key="2">
              <LicenceCommoditiesForm 
                button_command={"Add"}
                created_licence={this.props.licence_id}
                on__finish={()=>{}}
                licence_id={this.props.licence_id}
                />
             </TabPane>
             
             </Tabs>
        </div>
    )

    }

   
  }
}

export default CommoditiesTab; 
